//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	//#endregion

	//#region Style vars
	//#endregion

	//#region seting vars based off params

	//#endregion

	return {
		outerStyle: () => {
			return {
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
			};
		},
	};
}

export default Styles;
